import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { apiGetOrgunits, apiUpdateOrgunits } from "../../../api/ApiOrgunit";
import { apiGetEngagement, apiUpdateEngagement } from "../../../api/ApiEngagement";
import { BiSubdirectoryRight } from "react-icons/bi";

const ModalChoixOrgunits = (props) => {
  const { t } = useTranslation();
  const { idEngagement, ReduxInstanceId, show, handleClose } = props;
  const [orgunits, setOrgunits] = useState([]);
  const [engagementModal, setEngagementModal] = useState({
    orgUnits: [],
    orgUnitsInitiaux: [],
    orgUnitsModifies: [],
  });
  const [isModified, setIsModified] = useState(false);

  const recupEngagement = async () => {
    const res = await apiGetEngagement(ReduxInstanceId, idEngagement);
    setEngagementModal(res.data);
  };

  const recupOrgunits = async () => {
    const res = await apiGetOrgunits(ReduxInstanceId);
    setOrgunits(res.data);
  };

  const addRemoveOrgunit = async (idOrgunit) => {
    setIsModified(true);
    let orgUnits = [...engagementModal.orgUnits];

    // retrait d'un orgunit du tableau
    if (orgUnits.includes(idOrgunit)) {
      orgUnits = orgUnits.filter((item) => item !== idOrgunit);
    }
    // ajout d'un orgunit au tableau
    else {
      orgUnits.push(idOrgunit);
    }

    setEngagementModal({
      ...engagementModal,
      orgUnits: orgUnits,
    });
  };

  const saveBeforeClose = async () => {
    if (isModified) {
      const formData = new FormData();

      engagementModal.orgUnits.forEach((element) => {
        formData.append("orgUnits[]", element);
      });

      await apiUpdateEngagement(idEngagement, formData);
    }
    handleClose();
  };

  useEffect(() => {
    if (show) {
      setIsModified(false);
      recupEngagement();
      recupOrgunits();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  const RecursiveComponentOrgUnit = ({ objet, childrens, niveau }) => {
    let hasChildren = false;
    if (childrens && childrens.length) hasChildren = true;

    return (
      <>
        <InputGroup className="">
          {niveau !== 0 && (
            <BiSubdirectoryRight
              size="1.5em"
              className={"text-danger"}
              style={{ marginLeft: niveau * 15 + "px" }}
            />
          )}
          <Form.Check
            role="button"
            id={"orgunit_" + objet._id}
            type="switch"
            label={objet.nom}
            value={objet._id}
            onChange={(e) => {
              addRemoveOrgunit(e.target.value);
            }}
            checked={engagementModal.orgUnits.includes(objet._id) ? "checked" : ""}
          />
        </InputGroup>
        {hasChildren &&
          childrens.map((enfant) => (
            <RecursiveComponentOrgUnit
              key={enfant._id}
              objet={enfant}
              childrens={orgunits.filter((item) => item.orgUnitParent === enfant._id)}
              niveau={niveau + 1}
            />
          ))}
      </>
    );
  };

  return (
    <Modal show={show} onHide={saveBeforeClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminCollaborateurs.groupes")}
          {engagementModal.nom}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* ORGUNITS LEVEL 0 */}
        {orgunits
          .filter((orgunit) => orgunit.orgUnitParent === null)
          .map((orgunit) => (
            <RecursiveComponentOrgUnit
              key={orgunit._id}
              objet={orgunit}
              childrens={orgunits.filter((item) => item.orgUnitParent === orgunit._id)}
              niveau={0}
            />
          ))}
      </Modal.Body>
    </Modal>
  );
};

export default ModalChoixOrgunits;
